import React, { useState } from "react";
import { Button, Input } from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";

const ProviderFilterBar = ({
  dataAll = [],
  activeFilter = null,
  filterData,
  onSearchKeyFunc,
  handleDownloadData,
  displayMode,
  changeDisplayMode,
  showAddBtn,
  onAddClick,
}) => {

  const [searchVal, setSearchVal] = useState("");

  // Get unique item categories
  const itemNames = dataAll.map((item) =>
    (item.company_provider_item || []).map((i) => i.name)
  );
  const flatItemNames = [].concat.apply([], itemNames);
  const uniqueCategories = [...new Set(flatItemNames)];

  // Helper to calculate totals client-side
  const getTotals = (item) => {
    const items = item.company_provider_item || [];
    const income = items.reduce((acc, curr) => acc + (parseFloat(curr.price_income) || 0), 0);
    const outcome = items.reduce((acc, curr) => acc + (parseFloat(curr.price_outcome) || 0), 0);
    const pending = items.reduce((acc, curr) => acc + (parseFloat(curr.price_pending) || 0), 0);
    return { income, outcome, pending };
  };

  // Counts for chips
  const totalCount = dataAll.length;
  const paidCount = dataAll.filter((x) => {
    const { income, outcome } = getTotals(x);
    return income > 0 && outcome === income;
  }).length;
  const debtCount = dataAll.filter((x) => {
    const { pending } = getTotals(x);
    return pending > 0;
  }).length;
  const noTransCount = dataAll.filter((x) => {
    const { income } = getTotals(x);
    return income === 0;
  }).length;


  const handleSearchChange = (e) => {
    setSearchVal(e.target.value);
    onSearchKeyFunc(e);
  };

  const handleSearchKeyPress = (e) => {
    onSearchKeyFunc(e);
  };

  // Determine active tab chip
  let activeTabKey = "all";
  if (activeFilter) {
    if (activeFilter.column === "outcome-equal-income" && activeFilter.value === "0") {
      activeTabKey = "paid";
    } else if (activeFilter.column === "outcome-lessthan-income" && activeFilter.value === "0") {
      activeTabKey = "debt";
    } else if (activeFilter.column === "total_price_income" && activeFilter.value === "0") {
      activeTabKey = "no-trans";
    }
  }

  return (
    <div className="provider-filter-container">
      <div className="filter-bar-row">
        <div className="filter-left-group">
          {/* Search Input */}
          {/* <div className="search-input-wrapper">
            <i className="simple-icon-magnifier" />
            <input
              type="text"
              placeholder="Tìm nhà cung cấp..."
              value={searchVal}
              onChange={handleSearchChange}
              onKeyPress={handleSearchKeyPress}
            />
          </div> */}

          {/* Nhóm hàng Filter Dropdown */}
          <select
            className="filter-select"
            defaultValue=""
            onChange={(e) => {
              const val = e.target.value;
              if (val) {
                filterData("item_product", val);
              } else {
                filterData("", "");
              }
            }}
          >
            <option value="">Nhóm hàng</option>
            {uniqueCategories.map((cat, idx) => (
              <option key={idx} value={cat}>
                {cat}
              </option>
            ))}
          </select>

          {/* Trạng thái Filter Dropdown */}
          <select
            className="filter-select"
            defaultValue=""
            onChange={(e) => {
              const val = e.target.value;
              if (val === "paid") {
                filterData("outcome-equal-income", "0");
              } else if (val === "debt") {
                filterData("outcome-lessthan-income", "0");
              } else if (val === "no-trans") {
                filterData("total_price_income", "0");
              } else {
                filterData("", "");
              }
            }}
          >
            <option value="">Trạng thái</option>
            <option value="paid">Đã trả hết</option>
            <option value="debt">Còn nợ</option>
            <option value="no-trans">Chưa có giao dịch</option>
          </select>

          {/* Công nợ Filter Dropdown */}
          <select
            className="filter-select"
            defaultValue=""
            onChange={(e) => {
              const val = e.target.value;
              if (val === "has-debt") {
                filterData("outcome-lessthan-income", "0");
              } else if (val === "no-debt") {
                filterData("outcome-equal-income", "0");
              } else {
                filterData("", "");
              }
            }}
          >
            <option value="">Công nợ</option>
            <option value="has-debt">Có công nợ</option>
            <option value="no-debt">Không có nợ</option>
          </select>

          {/* Thêm bộ lọc button */}
          {/* <button className="btn-add-filter">
            <i className="simple-icon-plus" />
            Thêm bộ lọc
          </button> */}
        </div>

        <div className="filter-right-group">
          {/* Excel export */}
          <button className="btn-export-excel" onClick={handleDownloadData}>
            <i className="simple-icon-cloud-download" />
            Excel
          </button>

          {showAddBtn && (
            <Button
              color="primary"
              onClick={onAddClick}
              style={{
                height: "38px",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "13px",
                padding: "0 16px",
                display: "flex",
                alignItems: "center",
                gap: "6px"
              }}
            >
              + Tạo nhà cung cấp
            </Button>
          )}

          {/* View mode toggle */}
          {/* <div className="view-mode-toggle">
            <button
              className={classnames("btn-view-toggle", {
                active: displayMode === "thumblist",
              })}
              onClick={() => changeDisplayMode("thumblist")}
              title="Dạng danh sách thẻ"
            >
              <i className="simple-icon-grid" />
            </button>
            <button
              className={classnames("btn-view-toggle", {
                active: displayMode === "list",
              })}
              onClick={() => changeDisplayMode("list")}
              title="Dạng bảng dữ liệu"
            >
              <i className="simple-icon-list" />
            </button>
          </div> */}
        </div>
      </div>

      {/* Tab chips below filters */}
      <div className="tab-chips-container">
        <div
          className={classnames("tab-chip", {
            active: activeTabKey === "all",
          })}
          onClick={() => filterData("", "")}
        >
          Tất cả <span className="tab-chip-count">{totalCount}</span>
        </div>
        <div
          className={classnames("tab-chip", {
            active: activeTabKey === "paid",
          })}
          onClick={() => filterData("outcome-equal-income", "0")}
        >
          Đã trả hết <span className="tab-chip-count">{paidCount}</span>
        </div>
        <div
          className={classnames("tab-chip", {
            active: activeTabKey === "debt",
          })}
          onClick={() => filterData("outcome-lessthan-income", "0")}
        >
          Còn nợ <span className="tab-chip-count">{debtCount}</span>
        </div>
        <div
          className={classnames("tab-chip", {
            active: activeTabKey === "no-trans",
          })}
          onClick={() => filterData("total_price_income", "0")}
        >
          Chưa giao dịch <span className="tab-chip-count">{noTransCount}</span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ProviderFilterBar);
